import { render, staticRenderFns } from "./AppointmentSettings.vue?vue&type=template&id=22d8a244&scoped=true&"
import script from "./AppointmentSettings.vue?vue&type=script&lang=js&"
export * from "./AppointmentSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentSettings.vue?vue&type=style&index=0&id=22d8a244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8a244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VDataTable,VDivider,VFlex,VForm,VLayout,VProgressLinear,VSlideYTransition,VSwitch})
